export const MODALS_NS = 'components/Modals';

export const i18n = {
  en: {
    error: {
      message: 'Failed to export the file.',
      tryAgain: 'Try again',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    settings: {
      saveChanges: 'Save changes',
      signOut: 'Sign out',
    },
    export: {
      title: 'You are about to export the raw data for BMT {{bmt}}',
      message: 'The data exported will match the raw data for the selected BMT.',
      exportingMessage: 'Exporting data...',
      loading: {
        title: 'Data is still loading',
        message: 'Your data still seems to be loading, please wait a moment.',
      },
      confirmText: 'Export',
      cancelText: 'Cancel',
      error: {
        message: 'Failed to export the file.',
        noData: 'There is no data.',
      },
    },
  },
};
